/**
 * The pale concentric line motif in the bottom right corner of the Portal
 * Productions letterhead - as geometry, not as artwork.
 *
 * It first went in as a cropped PNG, which was a mistake twice over: it was
 * the single largest asset in the app, and it turned out to be a family of
 * eight perfect circles in a strict arithmetic progression. Fitting them
 * against the supplied artwork (RANSAC over the motif's ink pixels, then a
 * least-squares refit on each circle's inliers) recovered the progression
 * exactly - centre stepping by (-21.207, +21.176) pt and radius by +6.847 pt,
 * eight times. Every one of the ~12,000 ink pixels in the motif is accounted
 * for by those eight circles.
 *
 * So it is drawn rather than stored: crisp at any size and any printer
 * resolution rather than fixed at the artwork's ~175 dpi, and it carries no
 * encoded payload that could be corrupted in transit.
 *
 * Circles k = 0..7, in points from the top-left of an A4 page. They run off
 * the right and bottom edges by design - exactly as on the letterhead - and
 * the PDF clips them at the page boundary.
 */
export const LETTERHEAD_ARCS = {
  count: 8,
  centreX: { start: 621.48, step: -21.207 },
  centreY: { start: 698.55, step: 21.176 },
  radius: { start: 137.26, step: 6.847 },
  /** Matched against the artwork by rendering both at 110 dpi and comparing. */
  strokeGrey: 204,
  strokeWidth: 0.4,
} as const

/** The eight circles as {x, y, r} in points, top-left origin. */
export function letterheadArcCircles(): { x: number; y: number; r: number }[] {
  const a = LETTERHEAD_ARCS
  return Array.from({ length: a.count }, (_unused, k) => ({
    x: a.centreX.start + a.centreX.step * k,
    y: a.centreY.start + a.centreY.step * k,
    r: a.radius.start + a.radius.step * k,
  }))
}
